import React from "react";
import { SidebarHeading, BackButton, Alert, MenuButton, EmptyBox } from "./styles";
import { ReactComponent as BackArrow } from "./../../atoms/icons/chevron-back.svg";
import { ReactComponent as Box } from "./../../atoms/icons/box.svg";
import { ReactComponent as BoxOpened } from "./../../atoms/icons/box-opened.svg";

export function Heading({
  mode,
  configPageUrl,
  calculatedDate,
  deliveryDate,
  handlePrevClick,
  sidebarStatus,
  selectedMeals,
  isExcludedMeals,
  toggleSidebarMobile,
}) {
  const renderButtonContent = () => {
    if (sidebarStatus === true) {
      return <BoxOpened />;
    }
    if (selectedMeals.breakfasts.length > 0 || selectedMeals.entrees.length > 0) {
      return <Box />;
    }

    return <EmptyBox />;
  };

  const renderAlert = (isExcludedMeals) => {
    return isExcludedMeals ? <Alert>!</Alert> : null;
  };

  return (
    <SidebarHeading level="2">
      {mode === "constructor" && (
        <>
          <BackButton href={configPageUrl}>
            <BackArrow />
          </BackButton>
          <span>My Meals for {calculatedDate}</span>
        </>
      )}
      {mode === "account" && (
        <>
          <BackButton
            href={configPageUrl}
            onClick={(e) => {
              handlePrevClick(e);
            }}
          >
            <BackArrow />
          </BackButton>
          <span>My Meals for {deliveryDate}</span>
        </>
      )}

      <MenuButton onClick={toggleSidebarMobile}>
        {renderButtonContent()}
        {renderAlert(isExcludedMeals)}
      </MenuButton>
    </SidebarHeading>
  );
}
